import {NgModule} from '@angular/core';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';


export function createTranslateLoader(http: HttpClient) {
  // Cache-buster: the i18n JSONs are not content-hashed like the JS bundles,
  // so browsers kept serving stale translations after deploys (JS-1802).
  return new TranslateHttpLoader(http, './assets/i18n/', '.json?v=' + Date.now());
}


@NgModule({
  imports: [
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      },
      isolate: false
    })
  ],
  exports: [
    TranslateModule
  ]
})

export class TranslateSharedModule {
}
